module.exports = __webpack_public_path__ + "assets/images/probe_4_wire.png";